import React from 'react';
import { useTranslation } from '../context/TranslationContext';
import '../styles/ConfirmationModal.css';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  type?: 'warning' | 'danger' | 'info';
  hideCancel?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
  type = 'warning',
  hideCancel = false
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  const getTypeStyles = () => {
    switch (type) {
      case 'danger':
        return {
          buttonColor: '#ef4444',
          buttonHoverColor: '#dc2626'
        };
      case 'info':
        return {
          buttonColor: '#3b82f6',
          buttonHoverColor: '#2563eb'
        };
      default:
        return {
          buttonColor: '#f59e0b',
          buttonHoverColor: '#d97706'
        };
    }
  };

  const styles = getTypeStyles();

  return (
    <div className="confirmation-modal-overlay" onClick={handleCancel}>
      <div className={`confirmation-modal confirmation-modal-type-${type}`} onClick={(e) => e.stopPropagation()}>
        <div className="confirmation-modal-header">
          <h3 className="confirmation-modal-title">{title}</h3>
        </div>

        <div className="confirmation-modal-body">
          <p className="confirmation-modal-message">{message}</p>
        </div>

        <div className="confirmation-modal-footer">
          {!hideCancel && (
            <button
              className="confirmation-modal-btn cancel-btn"
              onClick={handleCancel}
            >
              {cancelText || t('common.cancel')}
            </button>
          )}
          <button
            className="confirmation-modal-btn confirm-btn"
            onClick={handleConfirm}
            style={{
              backgroundColor: styles.buttonColor,
              '--hover-color': styles.buttonHoverColor
            } as React.CSSProperties & { '--hover-color': string }}
          >
            {confirmText || t('common.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
